<template>
  <WidgetWrapper
    v-loading="fullScreenLoading"
    title="Manual Data Pulling"
    :full-height="true"
    class="px-2"
  >
    <hr class="mb-2 -mt-2" />
    <div class="flex w-full justify-between mt-4">
      <el-button
        type="primary"
        icon="el-icon-s-tools"
        plain
        class="mr-4"
        @click="onEmailPopupClick(true)"
        >Notification Config</el-button
      >
      <el-button-group>
        <el-button
          @click="changeStatusFilter('All')"
          :type="statusFilter === 'All' ? 'primary' : ''"
          >All</el-button
        >
        <el-button
          @click="changeStatusFilter('FAILED')"
          :type="statusFilter === 'Failed' ? 'primary' : ''"
          >Failed</el-button
        >
        <el-button
          @click="changeStatusFilter('SUCCESS')"
          :type="statusFilter === 'Success' ? 'primary' : ''"
          >Success</el-button
        >
      </el-button-group>
      <el-button icon="el-icon-refresh" @click="fetchData"
        >Refresh Data</el-button
      >
    </div>
    <div id="form-container" class="pt-2">
      <el-table stripe :data="pagedTableData" style="width: 100%">
        <el-table-column
          type="index"
          header-align="center"
          align="right"
          sortable
          label="No"
          width="50"
        ></el-table-column>
        <el-table-column
          prop="Message"
          header-align="center"
          sortable
          label="Remark"
          width="100"
        ></el-table-column>
        <el-table-column
          prop="NameApi"
          header-align="center"
          sortable
          label="Process"
          width="150"
        ></el-table-column>
        <el-table-column
          header-align="center"
          sortable
          label="Detailed Description"
          width="auto"
        >
          <template slot-scope="scope">
            <div class="whitespace-pre-line">
              {{ scope.row.DetailedDescription }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="ParameterDate"
          header-align="center"
          sortable
          label="Data Date"
          width="110"
        ></el-table-column>
        <el-table-column
          prop="LastPull"
          header-align="center"
          sortable
          label="Last Pull"
          width="110"
        ></el-table-column>
        <!-- <el-table-column
          prop="DataSuccess"
          header-align="center"
          sortable
          label="Data Success"
          width="120"
        ></el-table-column>
        <el-table-column
          prop="DataFailed"
          header-align="center"
          sortable
          label="Data Failed"
          width="100"
        ></el-table-column> -->
        <el-table-column
          prop="Status"
          header-align="center"
          sortable
          label="Status"
          width="120"
        >
          <template slot-scope="scope">
            <el-tag
              :type="scope.row.Status === 'FAILED' ? 'danger' : 'SUCCESS'"
              effect="dark"
              class="w-full text-center"
            >
              {{ scope.row.Status }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column
          prop="action"
          header-align="center"
          label="Action"
          width="100"
        >
          <template slot-scope="scope">
            <div class="flex">
              <el-button
                type="success"
                :disabled="
                  scope.row.Status === 'SUCCESS' ||
                  scope.row.EnabledPull == false
                "
                icon="el-icon-refresh"
                size="small"
                @click="openPullDialog(scope.row)"
                >Pull</el-button
              >
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="flex w-full justify-end p-2">
        <el-pagination
          background
          class=""
          layout="prev, pager, next"
          :total="getData().length"
          :page-size="pageSize"
          @current-change="setPage"
        />
      </div>
    </div>
    <el-dialog
      v-loading="loadingPull"
      title="Form"
      :visible.sync="pullDialog"
      width="30%"
    >
      <span>Message</span>
      <el-input
        type="textarea"
        :rows="2"
        placeholder="Message is Optional"
        v-model="form.Message"
      >
      </el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="pullDialog = false">Cancel</el-button>
        <el-button type="primary" @click="pullData">Pull Data</el-button>
      </span>
    </el-dialog>
    <EmailSettingPopup
      title="Email Setting"
      :show-dialog="displayEmailSettingPopup"
      @onClose="onEmailPopupClick(false)"
    />
  </WidgetWrapper>
</template>

<script>
import WidgetWrapper from '@/components/WidgetWrapper'
import moment from 'moment'
import EmailSettingPopup from '@/components/Popup/EmailSetting.vue'

export default {
  components: {
    WidgetWrapper,
    EmailSettingPopup
  },
  data() {
    return {
      fullScreenLoading: false,
      loadingPull: false,
      statusFilter: '',
      form: {
        Id: '',
        Message: ''
      },
      tableData: [],
      pullDialog: false,
      tableDatas: [
        {
          no: 1,
          data: 'Device and Sensor Data only from DCE (Historical Data is Not Included)',
          lastPull: '4/20/2022 0:30',
          status: 'Failed',
          action: `Pull`
        },
        {
          no: 2,
          data: 'Historical data from all Sensor used in Formula',
          lastPull: '4/18/2022 0:30',
          status: 'Failed',
          action: `Pull`
        },
        {
          no: 3,
          data: 'Historical data from all Sensor used in Formula',
          lastPull: '4/19/2022 0:30',
          status: 'Failed',
          action: `Pull`
        },
        {
          no: 4,
          data: 'Historical data from all Sensor used in Formula',
          lastPull: '4/20/2022 0:30',
          status: 'Failed',
          action: `Pull`
        },
        {
          no: 5,
          data: 'Virtual Sensors',
          lastPull: '4/20/2022 0:30',
          status: 'Failed',
          action: `Pull`
        },
        {
          no: 6,
          data: 'Customer Data',
          lastPull: '4/20/2022 0:30',
          status: 'Failed',
          action: `Pull`
        }
      ],
      page: 1,
      pageSize: 10,
      status: ['FAILED', 'SUCCESS'],
      dataMessage: [
        'Device Sensor Data Only From DCE (Historical Data is Not Included)',
        'Historical data from All Sensor used in Formula',
        'Virtual Sensor',
        'Customer Data'
      ],
      displayEmailSettingPopup: false
    }
  },
  created() {
    let lastDate = new Date()
    let firstDate = moment(new Date()).add(-10, 'days')

    // for (let i = 1; i <= 7; i++) {
    //   this.tableData.push(
    //     {
    //       no: i,
    //       data: this.dataMessage[this.getRandomInt(0, 4)],
    //       lastPull: this.getRandomDate(firstDate, lastDate) + ' 0:30',
    //       status: this.status[this.getRandomInt(0, 2)],
    //       action: `Pull`
    //     }
    //   )
    // }
  },
  computed: {
    pagedTableData() {
      return this.getData().slice(
        this.pageSize * this.page - this.pageSize,
        this.pageSize * this.page
      )
    }
  },
  mounted() {
    this.fetchData()
  },
  methods: {
    setPage(val) {
      this.page = val
    },
    async openPullDialog(data) {
      try {
        this.form = {}
        this.pullDialog = true
        this.form = {
          Id: data.Id,
          Message: this.pullMessage
        }
      } catch (error) {
        this.form = {}
        this.pullDialog = false
        console.log(error)
      }
    },
    async pullData() {
      try {
        this.fullScreenLoading = true
        this.loadingPull = true
        await this.$axios.post(this.$appInfo.api.scheduler.pullData, this.form)
        this.fetchData()
        this.pullDialog = false
        this.fullScreenLoading = false
        this.loadingPull = false
      } catch (error) {
        this.loadingPull = false
        this.fullScreenLoading = false
        console.log(error)
      }
    },
    changeStatusFilter(val) {
      this.statusFilter = val
    },
    async fetchData() {
      try {
        this.fullScreenLoading = true
        const { data: res } = await this.$axios.get(
          this.$appInfo.api.scheduler.getAll
        )
        this.tableData = res
        await this.$store.dispatch('getAlarmsNotification')
        // console.log(res)
        this.fullScreenLoading = false
      } catch (error) {
        this.fullScreenLoading = false
        console.log(error)
      }
    },
    getData() {
      let statusFilter = this.statusFilter
      return this.tableData.filter(function (item) {
        if (statusFilter === 'FAILED' || statusFilter === 'SUCCESS') {
          return item.Status === statusFilter
        } else {
          return true
        }
      })
    },
    getRandomInt(min = 1, max = 10, withDecimal = false) {
      return withDecimal
        ? (Math.random() * (max - min) + min).toFixed(2)
        : Math.floor(Math.random() * (max - min) + min)
    },
    getRandomDate(date1, date2) {
      function randomValueBetween(min, max) {
        return Math.random() * (max - min) + min
      }

      let newDate1 = date1 || '01-01-1970'
      let newDate2 = date2 || new Date().toLocaleDateString()
      newDate1 = new Date(newDate1).getTime()
      newDate2 = new Date(newDate2).getTime()
      if (date1 > newDate2) {
        return new Date(randomValueBetween(newDate2, newDate1)).dateT()
      } else {
        return new Date(
          randomValueBetween(newDate1, newDate2)
        ).toLocaleDateString()
      }
    },

    onEmailPopupClick(val) {
      // manipulate display alarm state
      if (val) {
        this.displayEmailSettingPopup = false
      }

      this.displayEmailSettingPopup = val
    }
  }
}
</script>

<style scoped>
input:focus,
textarea:focus,
select:focus {
  outline: none !important;
}
</style>
